export const state = {
  moduleOpened: null,
  backgroundImage: {
    broiler: require('@/assets/trinovati-images/5.jpg'),
    matrix: require('@/assets/trinovati-images/4.jpg'),
    'laying-birds': require('@/assets/trinovati-images/laying-birds.jpg'),
    swine: require('@/assets/trinovati-images/swine.jpg'),
  },
  routes: [],
};
